<template>
    <b-form-group
            class="c-text"
            :description="description"
            :label="label"
            :label-for="id"
            :label-cols="labelCols"
            :aria-describedby="id + '_InvalidFeedback'">
        <Request
                ref="request"
                :onRequestSuccess="requestSuccess"
                :onRequestError="requestError"
                :options="{
                        showAlert: true,
                        blockOnProcessing: false,
                        blockTransparent: false,
                        blockImg: '',
                        blockSpinner: 'wave'
                }"
                :root="root">
            <slot slot="body">
                <InputSelect
                        v-if="dataLoading === false"
                        v-model="dataValue"
                        :options="dataProvinces"></InputSelect>
                <label v-else>{{Core.Definition.getDefinition('Chargement ...')}}</label>
            </slot>
        </Request>
        <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
            {{invalidFeedbackMessage}}
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
    import InputSelect from "./InputSelect"
    import Request from './Request'
    export default {
        name: 'InputProvince',
        extends: InputSelect,
        components: {
            InputSelect,
            Request
        },
        props: {
            root: {
                type: String,
                default: '/geolocation/provinces'
            },
            onRetrieve: {
                type: Function,
                default: function() {
                    return false
                }
            },
            onRequestSuccess: {
                type: Function,
                default: function() {
                    return false
                }
            },
            description: {
                type: String,
                default: ''
            },
            labelCols: {
                type: Number,
                default: 0
            },
            invalidFeedbackMessage: {
                type: String,
                default: ''
            },
        },
        watch: {
            value(val) {
                this.dataValue = val
            },
            dataValue(val) {
                this.$emit('input', val)
            }
        },
        mounted() {
            this.init()
        },
        data: () => {
            return {
                Core: window.Core,
                dataValue: null,
                dataSelectedValue: null,
                dataProvinces: [],
                dataLoading: false
            }
        },
        methods: {
            init() {
                this.dataValue = this.value
                this.dataProvinces = this.options
            },
            retrieve(country) {
                this.dataLoading = true
                this.onRetrieve(country)
                this.$refs.request.clearArgs()
                this.$refs.request.addArg('country', country)
                this.$refs.request.request()
            },
            requestSuccess(data) {
                if (undefined !== data.provinces) {
                    if (this.dataValue != null && this.dataValue.value === undefined) {
                        this.dataValue = Core.Select.select(this.dataValue, data.provinces)
                    }
                    this.dataProvinces = data.provinces
                }
                this.dataLoading = false
                this.onRequestSuccess(data)
            },
            requestError(data) {
            }
        }
    }
</script>